
import { Component, Mixins } from 'vue-property-decorator';
import { DevicesModule } from '~/store/modules/devices';
import Module from '~/components/Module.vue';
import { modulesOrder } from '~/models/helpers/constants';
import moduleFiltering from '~/mixins/moduleFiltering.mixin';

@Component({
    components: {
        Module,
    },
})
export default class ModulesLayout extends Mixins(moduleFiltering) {
    get modules() {
        let modules = DevicesModule.currentGatewayModules;
        const gatewayType = DevicesModule.currentGateway?.type;
        if (gatewayType) {
            // order modules vertically if a specific order is desired for the modules of the current gateway
            const order = modulesOrder[gatewayType];
            if (order) {
                modules = modules.sort((modA, modB) => {
                    const indexA = order.findIndex((moduleType) => moduleType === modA?.type);
                    const indexB = order.findIndex((moduleType) => moduleType === modB?.type);
                    return indexA >= 0 ? indexA - indexB : 1;
                });
            }
        }
        return modules;
    }
    get leftColumnModules() {
        return this.modules.filter((mod) => mod?.column === 'left');
    }
    get rightColumnModules() {
        return this.modules.filter((mod) => mod?.column === 'right');
    }
    isModuleShown(id: string) {
        const moduleData = this.modules.find((mod) => mod?.id === id);
        if (moduleData) {
            return this.isModuleFiltered(moduleData);
        }
    }
    isSelected(moduleId: string) {
        return moduleId === DevicesModule.currentModuleId;
    }
}
